import { CheckCircle2, Circle } from "lucide-react";

/**
 * The 6-tile care checklist (meals/medication/mobility/hygiene/behavior/
 * hydration). Stateless — receives current values via `checklist` and
 * toggles via `onToggle`. `items` is the list metadata so the parent
 * controls the order/labels/icons.
 */
export default function CareChecklist({ items, checklist, onToggle }) {
  return (
    <div className="card-surface p-4">
      <div className="label-eyebrow mb-3">Care Checklist</div>
      <div className="grid grid-cols-2 gap-2">
        {items.map((it) => {
          const active = checklist[it.key];
          return (
            <button
              key={it.key}
              onClick={() => onToggle(it.key)}
              data-testid={`check-${it.key}`}
              className={`flex items-center gap-3 rounded-xl border px-3 py-3 text-left transition-all min-h-[52px] ${
                active
                  ? "border-clinical-primary bg-clinical-primary/5"
                  : "border-clinical-border bg-white hover:border-clinical-primary/30"
              }`}
            >
              {active ? (
                <CheckCircle2 className="h-5 w-5 text-clinical-primary" />
              ) : (
                <Circle className="h-5 w-5 text-clinical-subtext" />
              )}
              <it.icon className="h-4 w-4 text-clinical-subtext" />
              <span className="text-sm font-medium">{it.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
